// Libs
import React from 'react';
import { Box, Typography } from '@mui/material';

// Components
import Rating from '../../../../../Rating';
import CountComponent from '../../CountComponent';
import OrderProductQtyLabels from '../../../../../Labels/OrderProductQtyLabels';
import ApprovalLabel from '../../../../../Labels/ApprovalLabel';
import ReportableIcon from '../../../../../Products/Card/ReportableIcon';

const getApprovalAlign = (isOutOfStock) => (isOutOfStock ? 'left' : 'right');

const DesktopView = ({
  product,
  order,
  orderItem,
  isRecurring,
  addressesCount,
  isDesktopMode,
  isOutOfStock,
  isUnavailableForOrder,
  unavailableLabel,
  classes,
  cx,
  onOpenModal,
  totalOrdered,
}) => {
  const {
    rating: isRatable,
    reportable: isReportable,
    product_description: description,
    prepack_quantity,
    size_vers: sizeVers,
  } = product || {};

  const renderQtyInfo = () => (
    <Box className={classes.qtyInfo}>
      <div className={classes.qtyInfoText}>
        <OrderProductQtyLabels
          orderItem={orderItem}
          addressesCount={addressesCount}
          isRecurring={isRecurring}
        />
      </div>
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="space-between">
        <Typography className={cx(classes.qtyInfoText, classes.totalItems)}>
          {`Total Items Ordered: ${prepack_quantity ? totalOrdered : 'N/A'}`}
        </Typography>
        {isReportable && <ReportableIcon />}
      </Box>
      {isUnavailableForOrder && (
        <Typography className={classes.outOfStockText}>
          {unavailableLabel}
        </Typography>
      )}
    </Box>
  );

  const renderRecurringButton = () =>
    isRecurring &&
    !isUnavailableForOrder && (
      <Box display="flex" gap={2} marginTop="auto">
        <Box flexBasis="57%"></Box>
        <Box flexBasis="43%" className={classes.buttonContainer}>
          <CountComponent
            product={product}
            orderItem={orderItem}
            order={order}
          />
        </Box>
      </Box>
    );

  const renderApprovalLabel = () =>
    !isRecurring &&
    isDesktopMode && (
      <ApprovalLabel
        orderItemStatus={orderItem.status}
        approver={orderItem.approval?.approver}
        isModified={orderItem.qty_ordered !== orderItem.qty_approved}
        align={getApprovalAlign(isOutOfStock)}
        className={classes.approvalLabel}
      />
    );

  return (
    <>
      <Box mb={1}>
        <Typography
          variant="h3"
          className={classes.productDescription}
          onClick={onOpenModal}
          width={isRecurring ? 'calc(100% - 40px)' : '100%'}>
          {description}
        </Typography>
        <Typography variant="textSm">{sizeVers}</Typography>
      </Box>
      {isRatable && (
        <div className={classes.ratingContainer}>
          <Rating product={product} />
        </div>
      )}
      {renderQtyInfo()}
      {renderRecurringButton()}
      {renderApprovalLabel()}
    </>
  );
};

export default DesktopView;
